<div [class]="to.className">
  {{ to.text }}
    <a [ngClass]="'btn btn-' + to.btnType" (click)="onClick($event)">
     {{to.linkText}}
    </a>
</div>